import shortNumberFormat from "./short_number_format";
import getPageStartEndIndexes from "./get_page_start_end_indexes";

const Utils = {
  shortNumberFormat,
  getPageStartEndIndexes
};

export default Utils;
